import { LocalizedAttributesValue, ModuleEnum } from '../generated/operations';
import { CONSTANTS } from '../components/constants';
import { isValveActuatorUnit } from 'src/utils/isValveActuatorUnit';
import { isAccessory } from 'src/utils/isAccessory';

const ValveRegExp = new RegExp(CONSTANTS.VALVE, 'i');

const detectWater = (type: string): ModuleEnum | null => {

  switch (true) {
    case ValveRegExp.test(type) === false: {
      return ModuleEnum.Water;
    }
    case ValveRegExp.test(type): {
      return ModuleEnum.WaterByValve;
    }
    default: {
      return null;
    }
  }
}

export function detectModule(
    section: LocalizedAttributesValue,
    type: LocalizedAttributesValue,
    category?: LocalizedAttributesValue
):ModuleEnum | null {
  if (category !== undefined && Array.isArray(category.raw) && category.raw.includes('Fire & Smoke')) {
    return ModuleEnum.FireAndSmoke;
  }
  const { raw: sectionValue = [] } = section || {};
  const { raw: typeValue = [] } = type || {};
  if (isAccessory(type)) {
    return ModuleEnum.Accessory;
  }
  if (isValveActuatorUnit(type)) {
    return ModuleEnum.Vau;
  }
  if (category && type && new RegExp(CONSTANTS.ACTUATOR, 'i').test(type.raw.join())) {
    if (new RegExp('Water', 'i').test(category.raw.join())) {
      return ModuleEnum.Water
    } else {
      return ModuleEnum.Air;
    }
  }
  switch (sectionValue[0]) {
    case CONSTANTS.RETROFIT_AIR_OLD:
    case CONSTANTS.RETROFIT_AIR: {
      return ModuleEnum.Air;
    }
    case CONSTANTS.RETROFIT_SENSOR_OLD:
    case CONSTANTS.RETROFIT_SENSOR: {
      return ModuleEnum.Sensor;
    }
    case CONSTANTS.RETROFIT_WATER_OLD:
    case CONSTANTS.RETROFIT_WATER: {
      return detectWater(typeValue.join(''));
    }
    default: {
      return null;
    }
  }
}

